// extracted by mini-css-extract-plugin
export default {"navLink":"nav_navLink__T-e+M"};